import type { GetOpenQuestionAnswerResponse } from '@genially/contracts';

import { useSidebarSummaryWithContentContext } from '../../../SidebarSummaryWithContent.context';

type AggregatedData = GetOpenQuestionAnswerResponse & { isHidden: boolean };

export const useOpenAnswersSidebarData = () => {
  const {
    summary: { data },
  } = useSidebarSummaryWithContentContext();

  return {
    aggregatedData: data as AggregatedData[],
    totalData: data.length,
  };
};
